import React from 'react';
import PropTypes from 'prop-types';
import style from './BinarySwitch.module.css';
import { Body3 } from '../../text/Text';

export const BinarySwitch = ({ label1, label2, value, setValue, margin }) => {
  return (
    <div className={style.container} style={{ margin }}>
      <div
        style={{ borderRadius: '3px 0 0 3px' }}
        className={value === true ? style.selected : style.notSelected}
        onClick={() => setValue(true)}
      >
        <Body3 fontWeight={600} margin="0">
          {label1}
        </Body3>
      </div>
      <div
        style={{ borderRadius: '0 3px 3px 0' }}
        className={value === false ? style.selected : style.notSelected}
        onClick={() => setValue(false)}
      >
        <Body3 fontWeight={600} margin="0">
          {label2}
        </Body3>
      </div>
    </div>
  );
};

BinarySwitch.propTypes = {
  label1: PropTypes.string,
  label2: PropTypes.string,
  setValue: PropTypes.func,
  value: PropTypes.bool,
  margin: PropTypes.string,
};
